module.exports = __webpack_public_path__ + "img/CH0000_default.0d2caa14.png";